import { axiosAjax } from '@app/src/config/axios';

export const paymentService = {
  async post(json: any): Promise<any> {
    try {
      const { data } = await axiosAjax.post(
        process.env.API_PAYMENT, json
      );
      if (data.error) {
        throw new Error();
      }
      return data.data && data.data.length > 0 ? data.data[0] : {};
    } catch (e) {
      throw new Error(e);
    }
  }
}
